import { FrontendError } from './frontend-error';
import {
  ApiError,
  BusinessRuleError,
  ForbiddenError,
  NetworkError,
  NotFoundError,
  ServerError,
  UnauthorizedError,
  UnknownApiError,
  ValidationError,
} from './api-error';

/**
 * The canonical UI surface for an error, keyed off its class per ADR 0014's
 * display-strategy table. Per-call overrides are explicit at the call site;
 * this registry is the default every consumer shares.
 */
export type ErrorSurface =
  'inline-form' | 'reauth' | 'page-forbidden' | 'page-not-found' | 'toast' | 'toast-reportable' | 'page-reportable';

export function resolveErrorSurface(err: ApiError | FrontendError): ErrorSurface {
  if (err instanceof ValidationError) return 'inline-form';

  if (err instanceof UnauthorizedError) return 'reauth';

  if (err instanceof ForbiddenError) return 'page-forbidden';

  if (err instanceof NotFoundError) return 'page-not-found';

  if (err instanceof BusinessRuleError) return 'toast';

  if (err instanceof ServerError || err instanceof NetworkError || err instanceof UnknownApiError) {
    return 'toast-reportable';
  }

  if (err instanceof FrontendError) return 'page-reportable';

  return 'toast-reportable';
}

/**
 * Reportable surfaces carry a copyable `error.id` and a retry affordance.
 * 4xx errors are never reportable — the absence of an id is the signal.
 */
export function isReportableSurface(surface: ErrorSurface): boolean {
  return surface === 'toast-reportable' || surface === 'page-reportable';
}
